import { getTestId } from '@airtel/air-design-system';
export var defaultProps = Object.assign({
  size: 'sm',
  value: '1',
  onDecrementButtonPressMetaData: {
    id: 'decrement'
  },
  onIncrementButtonPressMetaData: {
    id: 'increment'
  }
}, getTestId('CounterWidgetContainer'));